module.exports = __webpack_public_path__ + "img/it.ab7d14c7.svg";